import moment from 'moment';

export function hasMinimumAge(birthdate: Date | undefined) {
  return !!birthdate && moment().diff(moment(birthdate), 'years') > 11;
}

export function hasMaximumAge(birthdate: Date | undefined) {
  return !!birthdate && moment().diff(moment(birthdate), 'years') < 122;
}
